import { render, staticRenderFns } from "./readingHome.vue?vue&type=template&id=118a2e61&scoped=true&"
import script from "./readingHome.vue?vue&type=script&lang=js&"
export * from "./readingHome.vue?vue&type=script&lang=js&"
import style0 from "./readingHome.vue?vue&type=style&index=0&id=118a2e61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a2e61",
  null
  
)

export default component.exports